import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

import { PropertyService } from '../../services/property.service';
import { StartLeaseComponent } from '../start-lease/start-lease.component';

@Component({
  selector: 'app-editable-property-container',
  templateUrl: './editable-property-container.component.html',
  styleUrls: ['./editable-property-container.component.scss']
})
export class EditablePropertyContainerComponent implements OnInit {
  @Input()
  property;

  @Input()
  attributes;

  @Input()
  onEdit: (property: any) => void;

  activeLease: any = null;
  loadingLease = false;

  constructor(
    private router: Router,
    private propertyService: PropertyService
  ) { }

  ngOnInit() {
    if (this.property && this.property.id) {
      this.loadActiveLease();
    }
  }

  loadActiveLease() {
    this.loadingLease = true;
    this.propertyService.getActiveLease(this.property).then((lease) => {
      this.activeLease = lease;
      this.loadingLease = false;
    }).catch((error) => {
      console.error('Error loading active lease:', error);
      this.activeLease = null;
      this.loadingLease = false;
    });
  }

  goToProperty() {
    if (this.property && this.property.id) {
      this.router.navigate(['/view-property', this.property.id]);
    }
  }

  editProperty(event: Event) {
    event.stopPropagation();
    if (!this.property || !this.property.id) return;
    if (this.onEdit) {
      this.onEdit(this.property);
    } else {
      this.router.navigate(['edit-property', this.property.id]);
    }
  }

  manageLeases(event: Event) {
    event.stopPropagation(); // Prevent navigation to property view
    if (!this.property || !this.property.id) {
      return;
    }

    // Navigate to manage leases page with propertyId query parameter
    this.router.navigate(['manage-leases'], { queryParams: { propertyId: this.property.id } });
  }

  endLease(event: Event) {
    event.stopPropagation(); // Prevent navigation to property view
    if (!this.activeLease || !this.property || !this.property.id) {
      return;
    }

    if (!confirm(`Are you sure you want to end the lease for ${this.activeLease.firstName} ${this.activeLease.lastName}?`)) {
      return;
    }

    this.propertyService.endLease(this.property, this.activeLease).then(() => {
      // Refresh lease info
      this.loadActiveLease();
      // Refresh property to update status
      this.propertyService.clearProperties();
    }).catch((error) => {
      console.error('Error ending lease:', error);
      let errorMessage = 'Failed to end lease. Please try again.';
      if (error && error.error && error.error.error) {
        errorMessage = error.error.error;
      } else if (error && error.message) {
        errorMessage = error.message;
      }
      alert(errorMessage);
    });
  }

  isPropertyAvailable(): boolean {
    // Property is available if it has an ID and no active lease
    return this.property && this.property.id && !this.activeLease;
  }

}
